import React, { forwardRef, createContext, useContext, useMemo } from "react";
import type { ForwardedRef, PropsWithChildren } from "react";

import type {
    IInputProps,
    InputTextSize,
} from "../../../../components/InputText/types";

interface InputContainerContextValue extends PropsWithChildren {
    className?: string;
    style?: React.CSSProperties;
    inputChildren?: React.ReactNode;
    inputProps?: Omit<IInputProps, "size"> & {
        size?: InputTextSize;
    };
}

const Context = createContext(
    {} as InputContainerContextValue & { ref: ForwardedRef<HTMLLabelElement> },
);

export const InputContainerProvider = forwardRef<
    HTMLLabelElement,
    InputContainerContextValue & { children: React.ReactNode }
>(
    (
        {
            className,
            style,
            inputChildren,
            inputProps,
            children,
        }: InputContainerContextValue & { children: React.ReactNode },
        ref,
    ) => {
        const value = useMemo(() => {
            return {
                ref,
                className,
                style,
                inputChildren,
                inputProps,
            };
        }, [className, inputChildren, inputProps, ref, style]);
        return <Context.Provider value={value}>{children}</Context.Provider>;
    },
);
InputContainerProvider.displayName = "InputContainerProvider";

export const useInputContainerStore = () => {
    const context = useContext(Context);
    if (!context) {
        throw new Error(
            "useInputContainerStore должен использоваться внутри InputContainerProvider",
        );
    }
    return context;
};
